import {
  faq,
  faqEn,
  faqFin,
  supportFaq,
  supportFaqEn,
  supportFaqFin,
  supportFormFaq,
  supportFormFaqEn,
  supportFormFaqFin,
} from '@/constants/faq/data';
import { getLang } from '@/locale';

export const getSupportFaq = () => {
  const selectedLang = getLang();
  switch (selectedLang) {
    case 'fi':
      return supportFaqFin;
    case 'en':
      return supportFaqEn;
    default:
      return supportFaq;
  }
};

export const getSupportFormFaq = () => {
  const selectedLang = getLang();
  switch (selectedLang) {
    case 'fi':
      return supportFormFaqFin;
    case 'en':
      return supportFormFaqEn;
    default:
      return supportFormFaq;
  }
};

export const getFaq = () => {
  const selectedLang = getLang();
  switch (selectedLang) {
    case 'fi':
      return faqFin;
    case 'en':
      return faqEn;
    default:
      return faq;
  }
};

export const getHighlightedFaq = () => {
  return {
    questions: getSupportFaq()
      .reduce((acc, section) => {
        section.questions.forEach((q) => {
          q.section = section.path;
          acc.push({ ...q });
        });
        return [...acc];
      }, [])
      .map((item) => ({ item, sort: Math.random() })) // randomize questions
      .sort((a, b) => a.sort - b.sort) // randomize questions
      .map(({ item }, i) => {
        item.id = i + 1;
        return item;
      })
      .splice(0, 5),
  };
};
